import { authHeader } from '@/helpers';

export const productService = {
  get,
  getById,
  getByBarcode,
  getByCategoryId,
  add,
  update,
  remove,
  exportExcel,

  generateBarcode,
  updateCurrentStock,
  updateProductField,
  resetStock,

  getUniqueTags,
  getByTag,
};

async function get() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/get`, requestOptions)
    .then((response) => response.json())
    .then(responseJson => {
      return responseJson;
    });
}

async function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/getbyid?id=${id}`, requestOptions)
    .then((response) => response.json())
    .then(responseJson => {
      return responseJson;
    });
}

async function getByBarcode(barcode) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/getbybarcode?barcode=${barcode}`, requestOptions)
    .then((response) => response.json())
    .then(responseJson => {
      return responseJson;
    });
}

async function getByCategoryId(categoryId, recursive) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/getByCategoryId?id=${categoryId}&recursive=${recursive}`, requestOptions)
    .then((response) => response.json())
    .then(responseJson => {
      return responseJson;
    });
}

async function generateBarcode(product) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(product)
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/generatebarcode`, requestOptions)
}

async function add(category) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(category)
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/post`, requestOptions)
}

async function updateCurrentStock(productId, currentStock) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify({
      productId,
      currentStock
    })
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/updatestock`, requestOptions)
}

async function updateProductField(productId, fieldName, value) {
  const requestOptions = {
    method: 'PATCH',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      fieldName,
      value
    })
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/UpdateProductField/${productId}`, requestOptions)
}

async function resetStock(productIds) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(productIds)
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/resetstock`, requestOptions)
}

async function update(category) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(category)
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/put`, requestOptions)
}

async function remove(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/delete?id=${id}`, requestOptions)
}

async function exportExcel() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/export`, requestOptions)
}

async function getUniqueTags() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/getalluniquetags`, requestOptions)
    .then((response) => response.json())
    .then(responseJson => {
      return responseJson;
    });
}

async function getByTag(tag) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.VUE_APP_APIURL}/product/getbytag?tag=${tag}`, requestOptions)
    .then((response) => response.json())
    .then(responseJson => {
      return responseJson;
    });
}


// async function importExcel(base64) {
//   var dto = {
//     base64: base64
//   }

//   const requestOptions = {
//     method: 'POST',
//     headers: authHeader(),
//     body: JSON.stringify(dto)
//   };

//   return fetch(`${process.env.VUE_APP_APIURL}/product/import`, requestOptions)
// }